import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';

@NgModule({
  imports: [
  ],
  declarations: [
    HomeComponent
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/homepage/sys/home.module.ts